const routes = {
    conta: {
        autenticacao: 'api/Login/LoginPorSessao',
        verificaContratoAceito: 'interno/VerificaContratoAceito/5',
        salvarContratoAceito: 'interno/SalvarContratoAceito/5',
        obtemTermosUso: 'interno/ObtemTermoUso/5',
        logout: 'logout'
    },
    usuario:{
        base: 'usuario',
        obterDadosUsuario: 'usuario/obterDadosUsuario'
    },
    segurado: {
        base: 'segurado',
        confirmarMensagemImportacaoFontes: 'confirmarMensagemImportacaoFontes',
        checarExibicaoMensagemImportacaoFontes: 'mensagemImportacaoFontes'
    },
    importacao: {
        base: 'arquivo',
        listarHistorico: 'arquivo/historico',
        exportarHistorico: 'arquivo/historico/exportar',
        importar: 'arquivo/upload',
        planilhaCnis: 'planilha/cnis',
        planilhaFontesPagadoras: 'planilha/fontesPagadoras'
    },
    relacoesPrevidenciarias: {
        base: 'relacoes',
        listarRelacoes: 'relacoes/listar',
        atualizarRelacao: 'relacoes/atualizar',
        listarCnisFontes: 'relacoes/cnisfontespagadoras',
        atualizarCnisFontes: 'relacoes/cnisfontespagadoras/atualizar',
        listarRemuneracoes: 'relacoes/remuneracoes'
    },
    resultados: {
        base: 'resultado',
        listarResultados: 'resultado/listar',
        excluirResultado: 'resultado/excluir',
        exportarRelatorio: 'resultado/relatorio',
        listarResultadosDetalhado: 'resultado/detalhado',
        exportarRelatorioDetalhado: 'resultado/detalhado/relatorio',        
        exportarRelatorioDetalhadoCompleto: 'resultado/detalhado/relatorioCompleto'
    },
    restituicao: {
        base: 'restituicao',
        listarResultados: 'restituicao/listar',
        exportarRelatorio: 'restituicao/relatorio',
        buscarEspelho: 'restituicao/espelho',        
        buscarTodosEspelhos: 'restituicao/espelho/todos'
    }
}

export default routes